import { Avatar, Stack, Typography } from "@mui/material";
import { useDateService } from "hooks/useDateService";
import { Icon, iconMessageExclamation } from "theme/icons";
import { Broadcast } from "types/broadcast";

export const SystemMessageItem = ({ message }: { message: Broadcast }) => {
  const dateService = useDateService();
  const avatarSize = 40;

  return (
    <>
      <Avatar sx={{ bgcolor: "warning.light", width: avatarSize, height: avatarSize }}>
        <Icon name={iconMessageExclamation} htmlColor={"white"} />
      </Avatar>
      <Stack
        direction="column"
        sx={{ ml: 2 }}
        spacing={0.5}
        width={"calc(100% - 60px)"} // TODO: Make this calculation a little smarter
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography
            variant="body2"
            fontWeight={700}
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" }}
          >
            {message.subject ? message.subject : "Systemmeddelande"}
          </Typography>
          <Typography variant="subtitle2" color="grey.500">
            {dateService.getDateAsLocalDateString(message.created)}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography
            variant="subtitle2"
            // fontWeight={message.read ? undefined : 700}
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" }}
          >
            {message.content}
          </Typography>
        </Stack>
      </Stack>
      {/* {!message.read && <Icon name={iconNotification} color="info" size="small" sx={{ ml: "auto" }} />} */}
    </>
  );
};
